import styled from 'styled-components';

const kindColor = ({ $kind, theme }) => {
  if ($kind === 'bot') return theme.isDark ? '#8ea1ff' : '#4b63d4';
  if ($kind === 'freeAgent') return theme.isDark ? '#e6b325' : '#c48a00';
  return theme.success;
};

export const StyledKindIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 14px;
  height: 14px;
  color: ${kindColor};

  svg {
    display: block;
    width: 14px;
    height: 14px;
  }
`;
